module.exports = __webpack_public_path__ + "static/media/PIBKG_green.2ef0e8bf.png";